webpackJsonp([86274549634625],{

/***/ 359:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Gatsby + Netlify CMS Starter"}},"allMarkdownRemark":{"totalCount":1,"edges":[{"node":{"fields":{"slug":"/blog/2017-01-04-a-beginners-guide-to-brewing-with-chemex/"},"frontmatter":{"title":"A beginners’ guide to brewing with Chemex"}}}]}},"pathContext":{"tag":"chemex"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-chemex-1c0d6687bc1351e454f4.js